import React from "react";
import MenuIcon from "@material-ui/icons/Menu";
import "./shopNav.css";

/**
 * ShopTopbar - thin top bar shown above the routed page. Only carries
 * the current page title and the mobile menu toggle — the previous
 * version reserved space here for a notifications/profile menu
 * (components/Navbars/AdminNavbarLinks.js) that was commented out and
 * never actually shown, and a sidebar-minimize button that was also
 * commented out. Log out lives in one place (the sidebar) instead of
 * being duplicated here.
 */
const ShopTopbar = ({ title, onOpenMobile }) => {
  return (
    <header className="shopTopbar">
      <button type="button" className="shopTopbarMenuButton" onClick={onOpenMobile} aria-label="Open menu">
        <MenuIcon fontSize="small" />
      </button>
      <h1 className="shopTopbarTitle">{title}</h1>
    </header>
  );
};

export default ShopTopbar;
